import "./auth.css";
import { useState ,useRef ,useEffect,useContext} from 'react';
import { handleRegistration } from "../../api/utility";
import { Link , useNavigate } from "react-router-dom";
import Header from "../../component/Header/Header";
import { useTheme } from "../../context/theme-context";
import NoteContext from "my-webapp/context/NoteContext";


const RegistertestCredentials = {
    firstname : "pooja",
    email:"pooja@gmail.com",
    password:"12345",
    retypedPassword:"12345",
    lastname:"kumari",
    termsAndConditions:true,
    hideshowpassword:true,
    hideshow_rety_Pass:true,
  };

  const RegisterformInitialState = {
    firstname : "",
    email:"",
    password:"",
    retypedPassword:"",
    lastname:"",
    termsAndConditions:false,
    hideshowpassword:false,
    hideshow_rety_Pass:false,
  };

const Register =()=>{
    let navigator = useNavigate();
    const { darkTheme } = useTheme();
    let {toastdispatch} = useContext(NoteContext)

    const [formData, setFormData] = useState(RegisterformInitialState);
    const { firstname,email,password,retypedPassword,lastname,termsAndConditions,hideshowpassword,hideshow_rety_Pass } = formData;

    // const [firstname,setName] = useState("");
    // const [email, setemail] = useState("");
    // const [password, setPassword] = useState("");
    // const [retypedPassword, setRetypedPassword] = useState("");
    // const [error, setError] = useState("");
    // const [lastname,setLastName]=useState("");
    // const [termsAndConditions,settermsAndConditions]=useState(false);
    // const [hideshowpassword,sethideshowpassword]=useState(false);
    // const [hideshow_rety_Pass,Sethideshow_rety_Pass]=useState(false);

    useEffect(()=>{
        window.scrollTo({ behavior: 'smooth', top: '0px' });
    },[])

   
    const handleInput = (e) =>
    setFormData((prevFormData) => ({
    ...prevFormData,
    [e.target.name]: e.target.value,
}));

const handleToggle = (e) =>
    setFormData((prevFormData) => ({
    ...prevFormData,
    [e.target.name]: e.target.checked,
}));

const handleSubmit=(e)=>{
    e.preventDefault();

                      
    if(firstname && lastname && email && password && retypedPassword && password===retypedPassword  && termsAndConditions ){
        handleRegistration(email,password,firstname,lastname,termsAndConditions,navigator,toastdispatch).then(res=>{
             if(res.payload.status===201 || res.payload.status===200){
                 navigator('/login')
             }
        })
    }else if((password!==retypedPassword) && (retypedPassword!=="")){
        toastdispatch({type:'DANGER',payload:"Password not matched"})
    }else{
        toastdispatch({type:'DANGER',payload:"All fields are mandatory"})
    }
    
}

    return(
        <div>
            <Header layout={""} sidebarOpen={""}/>
            <div className="flex-row flex-justify-content-center flex-align-item-center box-container" style={{backgroundColor:darkTheme?"black":"white",color:darkTheme?"white":"black"}}>
                <div className={darkTheme?"auth-container-darkmood" : "auth-container"}>
                    <div className='flex-col'>
                    
                    <div className="flex-row justify-content-space-between flex-align-item-center">
                            <h4> Registration </h4>
                            <button className={'button-outline-primary button-onhover-fillbackground'} onClick={()=>setFormData(RegistertestCredentials)}> Fill with dummy data </button>
                    </div>
                    
                    <form onSubmit={(e)=>handleSubmit(e)}>
                        <div className="flex-row">
                            <section>
                                <div className="flex-row  col-gap-2rem textField-container">  
                                    <input type="text" name="firstName" value={firstname} placeholder="John" className="text-input" style={{color:darkTheme?"white":"black"}} onChange={handleInput} required/>
                                    <label className="text-placeholder"> Enter First Name </label>                                                
                                </div>
                                <div className="flex-row  col-gap-2rem textField-container">  
                                    <input type="text" name="lastName" value={lastname} placeholder="Doe" className="text-input" style={{color:darkTheme?"white":"black"}} onChange={handleInput} required/>
                                    <label className="text-placeholder"> Enter Last Name </label>                                                
                                </div>    
                                <div className="flex-row  col-gap-2rem textField-container">  
                                    <input type="email" name="email" value={email} placeholder="johndoe@gmail.com"  className="text-input" style={{color:darkTheme?"white":"black"}} onChange={handleInput} required/>
                                    <label className="text-placeholder"> Email Id </label>                                                
                                </div>
                            </section>
                            <section>
                                <div className="flex-row  col-gap-2rem textField-container">  
                                    <input type= {hideshowpassword?"text":"password"} name="password" value={password} className="text-input"  style={{color:darkTheme?"white":"black"}}  onChange={handleInput} required/>
                                    <input type="checkbox" className="check-show-password" value={hideshowpassword} checked={hideshowpassword} onChange={handleToggle} /> 
                                    <label className="text-placeholder"> Password </label>                                                
                                </div>
                                <div className="flex-row  col-gap-2rem textField-container">  
                                    <input type={hideshow_rety_Pass?"text":"password"} value={retypedPassword} className="text-input" style={{color:darkTheme?"white":"black"}} onChange={handleInput} required/>
                                    <input type="checkbox" className="check-show-password" value={hideshow_rety_Pass} checked={hideshow_rety_Pass} onChange={handleToggle} /> 
                                    <label className="text-placeholder"> Confirm password </label>                                             
                                </div>
                                <div className="flex-row  col-gap-2rem textField-container">  
                                    <input  type='checkbox' name="termsAndConditions" value={termsAndConditions} checked={termsAndConditions} onChange={handleToggle} required/>  
                                    <small > I accept all Terms & Conditions </small>                                         
                                </div>
                            </section>
                        </div>
                        
                        {/* <div className="flex-row flex-justify-content-center flex-align-item-center">
                            {(password!==retypedPassword) && (retypedPassword!=="") ? "password not matched" : ""}  
                            {error}
                        </div> */}
                        {/* {firstname && lastname && email && password && retypedPassword && password===retypedPassword && !error && termsAndConditions && (
                                    
                        )}    */}
                      
                        <div className="flex-row flex-justify-content-center flex-align-item-center">
                            <button className="button button-outline-primary button-onhover-fillbackground" type="submit"> sign up  </button>
                        </div>

                    </form>  
                    <div className="flex-row flex-justify-content-center flex-align-item-center typology-padding-top">
                    <Link to="/login"> Login </Link>
                    </div>
                </div>
            </div>
        </div>
    </div>
    )
 }
 
 export default Register